import React from 'react';
import { API_URL } from "../../constants";

import './ButtonReact.css';


// Trim the URL to remove reference to the backend
function formatHref(url) {
    if (!url) return '#'; // Return a default value if url is undefined or null
    return url.startsWith(API_URL) ? url.slice(API_URL.length) : url;
}



const ButtonReact = ({ button, onClick = null }) => {
    const href = button.target != '_blank' ? formatHref(button.url) : button.url;

    // Parse attributes if it's a string
    const additionalAttributes = {};
    if (typeof button.attributes === 'string') {
        const attributePairs = button.attributes.split(' ');
        attributePairs.forEach(pair => {
            const [key, value] = pair.split('=');
            additionalAttributes[key] = value ? value.replace(/['"]/g, '') : '';
        });
    }

    if (!href) return null;


    return (
        <a
            href={href}
            target={button.target}
            id={button.id}
            className={`c__button react group inline-block relative overflow-hidden font-copy text-white text-base text-[22px] md:text-xl font-medium leading-[30px] md:leading-[40px] ${button.class || ''}`}
            {...additionalAttributes}
            onClick={onClick} 
        >
            <span
                className="l__header-nav-item-initial |  py-1 xl:py-0 px-4 md:px-3 block transition-transform duration-450 group-hover:-translate-y-full"
                dangerouslySetInnerHTML={{ __html: button.title }}
            />
            <span
                className="l__header-nav-item-hover|  py-1 xl:py-0 px-4 md:px-3 w-full block absolute top-full left-0 transition-transform duration-450 group-hover:-translate-y-full w-full"
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: button.title }}
            />
        </a>
    );
};

export default ButtonReact;